import getMediaElement from 'editor/src/store/design/selector/getMediaElement';
import { updateMediaElementAction } from 'editor/src/store/design/slice';
import { ElementAddress, MediaImage } from 'editor/src/store/design/types';
import { getLinkedCollectionElements, LinkedCollectionElement } from 'editor/src/store/design/util/collectionLink';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';
import { buildAdvPersoPluginsUpdate, getAdvPersoDataFromElement } from 'editor/src/store/plugins/utils/advPersoUtils';

// Unlinks a single collection layer from its group. If that leaves exactly one member behind, that
// leftover is meaningless as a "group" (linking exists to tie 2+ layers together), so it's cleaned
// up too — its linkGroupId is removed as well.
const unlinkCollectionElementOperation =
  (elementAddress: ElementAddress) => (dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();
    const element = getMediaElement<MediaImage>(state, elementAddress);
    const data = element && getAdvPersoDataFromElement(element);
    if (!element || !data?.linkGroupId || !state.design.designData) {
      return;
    }

    const group = getLinkedCollectionElements(state.design.designData, data.linkGroupId);

    const isTargetAddress = (member: LinkedCollectionElement) =>
      member.address.spreadIndex === elementAddress.spreadIndex &&
      member.address.pageIndex === elementAddress.pageIndex &&
      member.address.elementIndex === elementAddress.elementIndex;

    const removeLink = (member: LinkedCollectionElement) => {
      const { linkGroupId, ...rest } = member.collectionInfo;
      dispatch(
        updateMediaElementAction({
          elementAddress: member.address,
          elementUpdate: { plugins: buildAdvPersoPluginsUpdate(member.element, rest) },
        }),
      );
    };

    group.filter(isTargetAddress).forEach(removeLink);

    const remaining = group.filter((member) => !isTargetAddress(member));
    if (remaining.length === 1) {
      removeLink(remaining[0]); // a group of one is meaningless
    }
  };

export default unlinkCollectionElementOperation;
